
<div id="control-container">

  <app-header></app-header>

  <main>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </main> 

  <app-footer></app-footer>

</div>

